import styled, { css } from 'styled-components';

export const MyAuditPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MyAuditListContainer = styled.div`
  margin-top: 55px;
`;

export const ContentContainer = styled.div``;

export const DepartmentHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const ButtonContainer = styled.div`
  gap: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.m};
  display: flex;
  justify-content: space-around;
`;

export const Description = styled.div`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const AuditorContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const AuditorContent = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const AuditorSectionContainer = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const DeleteTitleContainer = styled.div`
  text-align: center;
  padding: 0 ${({ theme }) => theme.fontSize.m};
`;

export const FilterModalHeaderContainer = styled.div`
  align-items: baseline;
  display: flex;
  margin: ${({ theme }) => theme.spacing.l} 0 ${({ theme }) => theme.spacing.xm}
    0;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  & .radio-with-label-label-wrapper {
    padding-left: ${({ theme }) => theme.spacing.s};
  }
  & .radio-with-label-label {
    font-size: ${({ theme }) => theme.fontSize.s};
  }
  & span {
    background-color: transparent !important;

    &:before {
      background-color: ${({ theme }) => theme.colors.verdigris};
      width: 12px;
      height: 12px;
    }
  }
  & .radio-with-label-label {
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-size: ${({ theme }) => theme.fontSize.s};
    color: ${({ theme }) => theme.colors.dimGray};
    letter-spacing: 0;
    line-height: ${({ theme }) => theme.lineHeight.lh5};
  }

  & .control-radio-overflow INPUT {
    display: none;
  }
`;

export const BottomSheetButtonSpacing = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.fontSize.s};
`;

export const PaddingBottomM = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const PaddingBottomL = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const PaddingBottomS = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const StatusRadioReceivedWrapper = styled.span(
  ({ theme, checked }) => css`
    & .radio-with-label-label {
      color: ${checked ? theme.colors.eerieBlack : theme.colors.dimGray};
    }
  `
);

export const StatusRadioCreatedByWrapper = styled.span(
  ({ theme, checked }) => css`
    & .radio-with-label-label {
      color: ${checked ? theme.colors.eerieBlack : theme.colors.dimGray};
    }
  `
);

export const StatusRadioAssessedWrapper = styled.span(
  ({ theme, checked }) => css`
    & .radio-with-label-label {
      color: ${checked ? theme.colors.eerieBlack : theme.colors.dimGray};
    }
  `
);

export const InputContainer = styled.div`
  justify-content: center;
  align-items: center;
  position: ${({ theme }) => theme.positions.relative};
  width: 100%;

  & .myaudit-filter-date-picker {
      height: ${({ theme }) => theme.height.h6};
      width: 100%;
      border: ${({ theme }) => `1px solid ${theme.colors.platinumDark}`};
      border-radius: ${({ theme }) => theme.spacing.s};
      padding: 0 11px; // added this temporarily when doing a myLqa revamp this will be removed
  }
`;

export const CalendarIconContainer = styled.div`
  position: ${({ theme }) => theme.positions.absolute};
  top: 14px;
  right: ${({ theme }) => theme.spacing.m};
`;

export const MyAuditDatePickerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const CardContentWrapper = styled.div`
  margin: 0 ${({ theme }) => theme.spacing.m};
`;

export const CreateNewMyAuditButtonContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
`;

export const NoResultContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing.xxl};
    gap: ${theme.spacing.m};
    align-items: center;
  `
);

export const NoDataMessageContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const DisabledSearchBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  border-radius: ${({ theme }) => theme.radius.s};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
`;

export const SearchFieldInput = styled.input`
  flex: 1;
  height: ${({ theme }) => theme.spacing.xm};
  margin-left: ${({ theme }) => theme.spacing.s};
  margin-right: ${({ theme }) => theme.spacing.s};
  border: none;
  background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.sm};
  outline: none;
  padding: 0;

  ::placeholder {
    color: ${({ theme }) => theme.colors.silver};
  }

  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.colors.dimGray};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colorsInObjects.gray[200]};
  }
`;

export const IconContainer = styled.div`
  display: flex;
`;
